import * as Sentry from '@sentry/vue'
import { Integrations } from '@sentry/tracing'

export function setupSentry (app, router) {
  const tracesSampleRate = process.env.NODE_ENV === 'development' ? 1.0 : 0.2

  Sentry.init({
    app,
    dsn: 'https://c1359a9c80fa4bbdb0445db82fc8fce0@o997495.ingest.sentry.io/6012926',
    integrations: [
      new Integrations.BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracingOrigins: ['localhost', /^\//],
      }),
    ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate,
    environment: process.env.NODE_ENV,
    logErrors: true,
    ignoreErrors: ['ResizeObserver loop limit exceeded'],
    release: 'escent-avenue-rayong@' + process.env.npm_package_version,
  })
}
